<span
  id="benchmark-option-dropdown-wrapper"
  class="{{originClass}}">
  <mat-select *ngIf="!fromPdf"
              class="benchmarkOption {{benchmarkClass}}"
              id="benchmark-option-dropdown"
              [placeholder]="benchmarkPlaceholder"
              [(value)]="selectedBenchmarkOption"
              (selectionChange)="updateBenchmarkOption($event.value)"
              hideSingleSelectionIndicator>
    <mat-option *ngFor="let benchMarkOption of benchmarkOptions"
                [disabled]="before2020 &&
                !(benchMarkOption.value === BenchmarkOption.Academic ||
                benchMarkOption.value === BenchmarkOption.Community)"
                [value]="benchMarkOption.value">{{benchMarkOption.name}}</mat-option>
  </mat-select>
  <span *ngIf="fromPdf" class="benchmarkOption {{benchmarkClass}}" id="benchmark-plain-text"
  >{{selectedBenchmarkOptionValue}}</span>
</span>
